import React from "react"
import { graphql, StaticQuery, Link } from "gatsby"
import styled from "@emotion/styled"
import { breakpoints, color, wrapper } from "../../utils/style"
import Cards2 from "../../icons/svg/Cards2"
import Img from "gatsby-image"

const BlockWrapper = styled("div")`
  margin: 20px 0 60px;
  .cards-icon {
    display: block;
    margin: 0 auto -40px;
  }
  h2 {
    text-transform: uppercase;
  }
`

const WrapperDesktop = styled("div")`
  ${wrapper}
`

const ProvidersWrapper = styled("div")`
  background: ${color.transparentDarkRed6};
  border: 2px solid ${color.red};
  margin-top: 40px;
  .providers {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    margin: 0 -10px;
  }
  .provider {
    flex-basis: 25%;
    padding: 10px;
    .gatsby-image-wrapper {
      width: 100%;
      max-width: 264px;
      display: block;
      margin: 0 auto;
    }
  }
  @media(max-width: ${breakpoints.md}) {
    .provider {
      flex-basis: 50%;
    }
  }
`

const GameProvidersNew = () => {
  return (
    <StaticQuery
      query={graphql`
        {
          allWordpressPage(filter: { slug: { eq: "home-page" } }) {
            edges {
              node {
                acf {
                  game_providers_new {
                    alt_text
                    title
                    path
                    acf {
                      slide_url
                      slide_title
                      slide_description
                    }
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 264) {
                          ...GatsbyImageSharpFluid_withWebp_noBase64
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const page = data?.allWordpressPage?.edges[0]?.node
        const gallery = page?.acf?.game_providers_new
        return (
          <BlockWrapper>
            <WrapperDesktop>
              <div className="title-wrap">
                <Cards2 className={"cards-icon"} />
                <h2 className="h1 rich-design a-center">
                  <span>บริการเพิ่มเติมนอกเหนือจาก Casino Royal1688</span>
                </h2>
              </div>
            </WrapperDesktop>
            <ProvidersWrapper>
              <WrapperDesktop>
                <div className="providers">
                  {gallery?.map((item, index) => {
                    const localFile = item?.localFile || {}

                    return (
                      <div className="provider" key={index + Math.random() * 100}>
                        <Link
                          to={
                            item.acf.slide_url
                              ? item.acf.slide_url
                              : "/register/"
                          }
                        >
                          {localFile?.childImageSharp &&
                            localFile?.childImageSharp?.fluid && (
                              <Img
                                fluid={localFile.childImageSharp.fluid}
                                alt={
                                  item.alt_text
                                    ? item.alt_text
                                    : "royal-1688.net"
                                }
                                fadeIn={false}
                                loading="eager"
                              />
                            )}
                        </Link>
                      </div>
                    )
                  })}
                </div>
              </WrapperDesktop>
            </ProvidersWrapper>
          </BlockWrapper>
        )
      }}
    />
  )
}

export default GameProvidersNew
